import React from 'react'
import InvoiceItemForm from './InvoiceItemForm'
import './styles.css'
import { useApiContext } from "../../hooks/useApiContext";
import { Items } from "../../services/items";
import { CloseOutlined} from "@ant-design/icons";
import { Button } from 'antd';

import './styles.css'


export default function InvoiceItems(props) {
  const {items, invoiceItemdispatch} = useApiContext();

  const deleteItem = (id) => {
    const getitems = items.filter((x) => x.id !== id);
    Items.delete(invoiceItemdispatch, getitems);
    console.log("Id", items);
  };
  return (
    <>
    <table class="table table-bordered">
    <thead>
            <tr>
              <td>
                البند
                <br />
                item
              </td>
              <td>
                الوصف
                <br />
                Description
              </td>
              <td>
                السعر
                <br />
                Price
              </td>
              <td>
                الكمية
                <br />
                Quantity
              </td>
              <td>
                قيمة الضريبة
                <br />
                Total Amount 
              </td>
              <td>
                الاجمالي مع الضريبة
                <br />
                Total with VAT
              </td>
            </tr>
          </thead>
          <tbody>
          {items.map((item, i) => (
              <>
                <tr>
                  <td>{i == 0 ? 1 : i + 1}</td>
                  <td>{item.description}</td>
                  <td>{item.price}</td>
                  <td>{item.quantity}</td>
                  <td>{(item.price * item.quantity).toFixed(2)}</td>
                  <td>
                    {item.withoutVat? (item.price * item.quantity).toFixed(2): (item.amount + item.price * item.quantity * 0.15).toFixed(2)}
                    <Button
                      style={{ marginLeft: "10px" }}
                      onClick={() => deleteItem(item.id)}
                      danger
                      icon={<CloseOutlined />}
                      size="small"
                      shape="circle"
                    />
                  </td>
                </tr>
              </>
            ))}
            <td colSpan={6}>
              {props.saved && 
              
                <InvoiceItemForm/>
              }
            </td>
            <tr>
            <td colSpan={5} className="text-right f-bold p-10">
              الكمية الإجمالية
              <br />
                Total Quantity:
              </td>
              <td>
                {items.reduce((a,b)=> a+b.quantity, 0)}
              </td>
            </tr>
            <tr>
             
              <td colSpan={5} className="text-right f-bold p-10">
                الاجمالي قبل الضريبة
                <br />
                Total before VAT:
              </td>
              <td>SR {(items.reduce((a, b) => a + b.amount, 0)).toFixed(2)}</td>
            </tr>
            <tr>
              <td colSpan={5} className="text-right f-bold p-10">
                الاجمالي بعد الضريبة
                <br />
                Total VAT Amount:
              </td>
              <td>SR {items.length>0?items[0].withoutVat?0:(items.reduce((a, b) => a + b.amount, 0) * 0.15).toFixed(2):[]}</td>
            </tr>
            <tr>
              <td colSpan={5} className="text-right f-bold p-10">
                الرصيد المستحق
                <br />
                Due Amount:
              </td>
              <td>
                SR{" "}
                {items.length>0?items[0].withoutVat?items.reduce((a, b) => a + b.amount, 0).toFixed(2):(items.reduce((a, b) => a + b.amount, 0) +
                  items.reduce((a, b) => a + b.amount, 0) * 0.15).toFixed(2):[]}
              </td>
            </tr>
          </tbody>

    </table>
    </>
  )
}
